export const enum VisualPosition {
  TOP = 'Top',
  BOTTOM = 'Bottom',
  RIGHT = 'Right',
  LEFT = 'Left',
  CENTERED = 'Centered',
  DEFAULT = 'Default for current module'
}

export type VisualPositionOption = `${VisualPosition}`;
